module.exports = __webpack_public_path__ + "static/media/3.Industrial Welding Machine.83cb2d4d.jpg";